import '../scss/main.scss';
import '../scss/contact.scss';
import './_common.js';
import getNearbyOffices from './util/nearbyOffice.js';
import Vue from './_vue-signleton';
import ContactForm from './components/contact-form';

Vue.setOptions({
  components: { ContactForm },
  data: function() {
    return {
      nearbyOffice: null,
      submitted: /success/.test(window.location.search)
    };
  },

  mounted: function() {
    if (this.submitted) {
      window.history.replaceState({}, window.document.title, window.location.pathname);
      setTimeout(() => {
        let successEl = this.$el.querySelector('.success');
        if (successEl) {
          window.scrollTo({
            // Add 100px for the nav
            top: successEl.parentElement.getBoundingClientRect().top - 100,
            behavior: 'smooth'
          });
        }
      }, 500);

      let todayMonth = new Date().getMonth(),
        todayDate = new Date().getDate();

      if (todayMonth === 11 && todayDate >= 24) {
        document.querySelector('.success.holiday').classList.remove('hidden');
      } else if (todayMonth === 0 && todayDate >= 1 && todayDate <= 4) {
        document.querySelector('.success.holiday').classList.remove('hidden');
      } else {
        document.querySelector('.success:not(.holiday)').classList.remove('hidden');
      }
      return;
    }

    getNearbyOffices()
      .then((office) => {
        this.nearbyOffice = office;
      })
      .catch((e) => {
        this.$refs.officeDetails.style.display = 'none';
      });
  },
  methods: {}
});
